import { FC, ChangeEvent } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import colors from "../../styles/colors";

const Container = styled.div`
    & select {
        padding: 8px 14px;
        font-size: 15px;
        color: white;
        background-color: ${colors.bgColorBlack2};
        border: 2px solid rgba(255, 255, 255, 0.15);
        border-radius: 6px;
        outline: none;
        cursor: pointer;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;

        &:focus {
            border-color: gold;
            box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.15);
        }

        & option {
            background-color: ${colors.bgColorBlack2};
            color: white;
        }
    }
`;

interface SelectYearProps {
    onChangeYearYetSet?: (year: string) => void;
}

const SelectYear: FC<SelectYearProps> = (props) => {
    const firstYear = 2005;
    const lastYear = new Date().getFullYear();
    const years: number[] = [];
    for (let year = lastYear; year >= firstYear; year--) {
        years.push(year);
    }

    const navigate = useNavigate();

    function handleYearChangePage(event: ChangeEvent<HTMLSelectElement>): void {
        if (event.target.value === 'all') {
            let url = '/ppv';
            navigate(url);
            return;
        }
        if (props.onChangeYearYetSet) {
            props.onChangeYearYetSet(event.target.value);
        } else {
            let url = '/ppv/byyear/' + event.target.value;
            navigate(url);
        }
    }

    return (
        <Container className="col-4 d-flex justify-content-center">
            <select onChange={handleYearChangePage}>
                <option value='all'>Seleziona un anno</option>
                {years.map((year, index) => (
                    <option key={index} value={year}>{year}</option>
                ))}
            </select>
        </Container>
    );
};

export default SelectYear;
